<script>
/**
 * renderer组件
 */
export default {
  name: "SjRenderer",
  props: {
    render: Function,
    props: {
      type: null
    }
  },
  render(h) {
    if (!this.render || typeof this.render !== "function") {
      return <div>Render function not provided.</div>;
    }

    return this.render(h, this.props);
  }
};
</script>
